/**
 * NodeDrill — a generic drill-down modal that renders arbitrary content
 * (`req.node`). Founder 2026-07-14: the acquisition section's "View by channel"
 * links used to reveal an inline card ON the page ("it messes everything up...
 * a very strange workflow"). They now open the by-channel breakdown as a real
 * pop-up drill, matching every other drill-down. Same modal chrome as RatioDrill
 * (overlay, header, Esc/close, scroll-lock) so it reads identically.
 *
 * Rendered by DrillProvider in place of DrillExplorer when req.node is set.
 */

import { useEffect } from "react";
import type { DrillRequest } from "./DrillExplorer.js";

export function NodeDrill({ req, onClose, originLabel = "Dashboard" }: { req: DrillRequest; onClose: () => void; originLabel?: string }): React.ReactElement {
  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [onClose]);

  return (
    <div style={overlay} role="dialog" aria-modal="true">
      <div style={headerBar}>
        <div style={{ minWidth: 0 }}>
          <div style={crumb}>
            <button onClick={onClose} style={crumbLink}>{originLabel}</button>
            <span style={{ color: "var(--faint)" }}> › </span>
            <span style={{ color: "var(--text)", fontWeight: 600 }}>{req.title}</span>
          </div>
          <h2 style={{ margin: "2px 0 0", fontSize: 21 }}>{req.title}</h2>
        </div>
        <button onClick={onClose} style={closeBtn} aria-label="Close">✕</button>
      </div>
      <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "20px 22px" }}>
        <div style={{ maxWidth: 920, margin: "0 auto" }}>{req.node}</div>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = { position: "fixed", inset: 0, background: "var(--bg)", zIndex: 100, display: "flex", flexDirection: "column", animation: "dd-fade-in .14s ease" };
const headerBar: React.CSSProperties = { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap", padding: "14px 22px", borderBottom: "1px solid var(--border)", background: "var(--surface)" };
const crumb: React.CSSProperties = { fontSize: 12, color: "var(--body)" };
const crumbLink: React.CSSProperties = { background: "transparent", border: "none", padding: 0, color: "var(--accent)", fontSize: 12, fontWeight: 600, cursor: "pointer" };
const closeBtn: React.CSSProperties = { border: "1px solid var(--border)", background: "var(--surface-2)", color: "var(--body)", width: 32, height: 32, borderRadius: "var(--r-sm)", cursor: "pointer", fontSize: 13, flexShrink: 0 };
